import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ title, dark = false, note }) => (
  <div
    className={`flex items-baseline gap-5 border-b pb-5 mb-12 ${
      dark ? "border-slate-700" : "border-slate-300"
    }`}
  >
    <span
      className={`text-sm font-bold tracking-[0.25em] uppercase ${
        dark ? "text-slate-400" : "text-slate-500"
      }`}
    >
      {title}
    </span>
    {note && (
      <span className="font-mono text-xs text-slate-400 tracking-widest">
        {note}
      </span>
    )}
    <span className="ml-auto hidden md:block font-mono text-xs text-slate-400 tracking-widest">
      THERMOGLASSPRO / MALTA
    </span>
  </div>
);
